import React from "react";
import { Button } from "react-bootstrap"

function areEqual(prevProps, nextProps) {
    return prevProps.className === nextProps.className
}

function TooltipOverlay({ tooltip, children }) {
    return (
        <div className="position-relative tooltip-overlay">
            {children}
            <div className="position-absolute overlay">
                <p className="m-0">{tooltip}</p>
            </div>
        </div>
    );
};

const LeftBarButton = (props) => {
    return (
        <TooltipOverlay tooltip={props.tooltip}>
            <Button
                variant="primary"
                className={props.className}
                onClick={props.onClick}
            >
                {props.children}
            </Button>
        </TooltipOverlay>
    );
};

export default React.memo(LeftBarButton, areEqual);